export default __webpack_public_path__ + "static/media/Invoice_Filled.6b3d6345.svg";